import ConfirmationModal from './ConfirmationModal'

export * from './ConfirmationModal'

export default ConfirmationModal
